'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _React = require('React');

var _React2 = _interopRequireDefault(_React);

var _reactRedux = require('react-redux');

var _debounce = require('transmute/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _reactDom = require('react-dom');

var _UIAlert = require('UIComponents/alert/UIAlert');

var _UIAlert2 = _interopRequireDefault(_UIAlert);

var _ComponentWithWindowListeners = require('UIComponents/mixins/ComponentWithWindowListeners');

var _ComponentWithWindowListeners2 = _interopRequireDefault(_ComponentWithWindowListeners);

var _CompanyLogo = require('MeetingsLib/components/decorative/CompanyLogo');

var _CompanyLogo2 = _interopRequireDefault(_CompanyLogo);

var _CompactBookingPage = require('MeetingsLib/components/page/CompactBookingPage');

var _CompactBookingPage2 = _interopRequireDefault(_CompactBookingPage);

var _FullSizeBookingPage = require('MeetingsLib/components/page/FullSizeBookingPage');

var _FullSizeBookingPage2 = _interopRequireDefault(_FullSizeBookingPage);

var _TroubleshootModeToggle = require('MeetingsLib/components/header/TroubleshootModeToggle');

var _TroubleshootModeToggle2 = _interopRequireDefault(_TroubleshootModeToggle);

var _AutoSubmitSelector = require('MeetingsLib/selectors/AutoSubmitSelector');

var _BookInfoSelectors = require('MeetingsLib/selectors/BookInfoSelectors');

var _LegalConsentFormSelectors = require('MeetingsLib/selectors/LegalConsentFormSelectors');

var _LocalizationSelectors = require('MeetingsLib/selectors/LocalizationSelectors');

var _RequestStatusSelectors = require('MeetingsLib/selectors/RequestStatusSelectors');

var _TroubleshootingSelectors = require('MeetingsLib/selectors/TroubleshootingSelectors');

var _BookActions = require('MeetingsLib/redux/actions/BookActions');

var BookActions = _interopRequireWildcard(_BookActions);

var _FormActions = require('MeetingsLib/redux/actions/FormActions');

var FormActions = _interopRequireWildcard(_FormActions);

var _UIActions = require('MeetingsLib/redux/actions/UIActions');

var UIActions = _interopRequireWildcard(_UIActions);

var _UsageTracker = require('MeetingsLib/tracking/UsageTracker');

var _UserProfile = require('MeetingsBase/models/UserProfile');

var _UserProfile2 = _interopRequireDefault(_UserProfile);

var _Branding = require('MeetingsBase/models/Branding');

var _Branding2 = _interopRequireDefault(_Branding);

var _UserMessage = require('MeetingsLib/models/UserMessage');

var _UserMessage2 = _interopRequireDefault(_UserMessage);

var _BookingLifecycle = require('MeetingsLib/models/BookingLifecycle');

var _BookingLifecycle2 = _interopRequireDefault(_BookingLifecycle);

var _FormState = require('MeetingsLib/models/FormState');

var _FormState2 = _interopRequireDefault(_FormState);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPACT_BREAKPOINT = 632;

var Booking = _React2.default.createClass({
  displayName: 'Booking',

  mixins: [_ComponentWithWindowListeners2.default],

  propTypes: {
    // passed
    avatar: _React.PropTypes.string,
    branding: _React.PropTypes.instanceOf(_Branding2.default).isRequired,
    headline: _React.PropTypes.string,
    hideLogo: _React.PropTypes.bool,
    profile: _React.PropTypes.instanceOf(_UserProfile2.default).isRequired,
    submittingMeeting: _React.PropTypes.bool,
    // loaded
    bookingLifecycle: _React.PropTypes.instanceOf(_BookingLifecycle2.default).isRequired,
    formState: _React.PropTypes.instanceOf(_FormState2.default),
    legalConsentEnabled: _React.PropTypes.bool,
    legalConsentResponses: _React.PropTypes.instanceOf(_immutable.List),
    canAutoSubmitPropertyForm: _React.PropTypes.bool,
    autoSubmitPropertyFormInvalid: _React.PropTypes.bool,
    embedded: _React.PropTypes.bool.isRequired,
    forceMobile: _React.PropTypes.bool,
    isFetchingPublicAvailability: _React.PropTypes.bool.isRequired,
    isFetchingPublicGlobalBranding: _React.PropTypes.bool.isRequired,
    canTroubleshoot: _React.PropTypes.bool,
    toggleTroubleshootMode: _React.PropTypes.func.isRequired,
    localeFromProps: _React.PropTypes.string,
    localeFromSettings: _React.PropTypes.string,
    setActiveLocale: _React.PropTypes.func.isRequired,
    shouldShowEmailForm: _React.PropTypes.bool,
    userMessage: _React.PropTypes.instanceOf(_UserMessage2.default)
  },

  getInitialState: function getInitialState() {
    return { compact: false, showedEmailForm: false };
  },
  componentWillMount: function componentWillMount() {
    var forceMobile = this.props.forceMobile;


    if (forceMobile || window.innerWidth < COMPACT_BREAKPOINT) {
      this.setState({ compact: true });
    }
  },
  componentDidMount: function componentDidMount() {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    (0, _UsageTracker.track)('meetingsLibViewScreen', { subscreen: 'book' });

    this.handleResizeIFrame();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var languageFromSettings = nextProps.languageFromSettings,
        localeFromProps = nextProps.localeFromProps,
        localeFromSettings = nextProps.localeFromSettings,
        shouldSetLocaleFromProps = nextProps.shouldSetLocaleFromProps,
        shouldSetLocaleFromSettings = nextProps.shouldSetLocaleFromSettings;


    this.maybeChangeActiveLocale(shouldSetLocaleFromProps, localeFromProps, shouldSetLocaleFromSettings, localeFromSettings, languageFromSettings);
  },
  maybeChangeActiveLocale: function maybeChangeActiveLocale(shouldSetLocaleFromProps, localeFromProps, shouldSetLocaleFromSettings, localeFromSettings, languageFromSettings) {
    var setActiveLocale = this.props.setActiveLocale;


    if (shouldSetLocaleFromProps) {
      setActiveLocale(localeFromProps);
    } else if (shouldSetLocaleFromSettings) {
      // Locale from link API response
      _I18n2.default.langEnabled = languageFromSettings !== 'en';
      setActiveLocale(localeFromSettings);
    }
  },
  markShowedEmailForm: function markShowedEmailForm() {
    this.setState({ showedEmailForm: true });
  },
  shouldShowEmailForm: function shouldShowEmailForm() {
    return this.props.shouldShowEmailForm && !this.state.showedEmailForm;
  },
  getContainerNode: function getContainerNode(element) {
    if (element) {
      this.containerNode = (0, _reactDom.findDOMNode)(element);
    }
  },
  getWindowListeners: function getWindowListeners() {
    var embedded = this.props.embedded;

    var resizeHandler = embedded ? this.handleResize : (0, _debounce2.default)(100, this.handleResize);
    return { resize: resizeHandler };
  },
  handleResize: function handleResize(e) {
    var forceMobile = this.props.forceMobile;
    var compact = this.state.compact;


    if (forceMobile) {
      return this.handleResizeIFrame();
    }

    if (e.target.innerWidth < COMPACT_BREAKPOINT && !compact) {
      this.setState({ compact: true });
    } else if (e.target.innerWidth >= COMPACT_BREAKPOINT && compact) {
      this.setState({ compact: false });
    }

    return this.handleResizeIFrame();
  },
  getNextIFrameHeight: function getNextIFrameHeight() {
    return this.containerNode.getBoundingClientRect().height + 25;
  },
  handleResizeIFrame: function handleResizeIFrame() {
    if (this.props.embedded && this.containerNode) {
      var height = this.getNextIFrameHeight();
      parent.postMessage({ height: height }, '*');
    }
  },
  getBookingComponent: function getBookingComponent() {
    return this.state.compact ? _CompactBookingPage2.default : _FullSizeBookingPage2.default;
  },
  renderBookInterface: function renderBookInterface() {
    var _props = this.props,
        avatar = _props.avatar,
        bookingLifecycle = _props.bookingLifecycle,
        formState = _props.formState,
        legalConsentEnabled = _props.legalConsentEnabled,
        legalConsentResponses = _props.legalConsentResponses,
        branding = _props.branding,
        canAutoSubmitPropertyForm = _props.canAutoSubmitPropertyForm,
        autoSubmitPropertyFormInvalid = _props.autoSubmitPropertyFormInvalid,
        canTroubleshoot = _props.canTroubleshoot,
        embedded = _props.embedded,
        headline = _props.headline,
        isFetchingPublicAvailability = _props.isFetchingPublicAvailability,
        isFetchingPublicGlobalBranding = _props.isFetchingPublicGlobalBranding,
        profile = _props.profile,
        submittingMeeting = _props.submittingMeeting;


    var shouldShowEmailForm = this.shouldShowEmailForm();
    var Component = this.getBookingComponent();

    return _React2.default.createElement(Component, {
      avatar: avatar,
      bookingLifecycle: bookingLifecycle,
      formState: formState,
      legalConsentEnabled: legalConsentEnabled,
      legalConsentResponses: legalConsentResponses,
      branding: branding,
      canAutoSubmitPropertyForm: canAutoSubmitPropertyForm,
      autoSubmitPropertyFormInvalid: autoSubmitPropertyFormInvalid,
      canTroubleshoot: canTroubleshoot,
      embedded: embedded,
      headline: headline,
      isFetchingPublicAvailability: isFetchingPublicAvailability,
      isFetchingPublicGlobalBranding: isFetchingPublicGlobalBranding,
      markShowedEmailForm: this.markShowedEmailForm,
      profile: profile,
      shouldShowEmailForm: shouldShowEmailForm,
      submittingMeeting: submittingMeeting
    });
  },
  renderPotentialAlert: function renderPotentialAlert() {
    var userMessage = this.props.userMessage;


    if (userMessage) {
      return _React2.default.createElement(
        'div',
        { className: 'm-all-6' },
        _React2.default.createElement(
          _UIAlert2.default,
          { type: userMessage.type },
          userMessage.content
        )
      );
    }

    return null;
  },
  renderCompanyLogo: function renderCompanyLogo() {
    var _props2 = this.props,
        branding = _props2.branding,
        hideLogo = _props2.hideLogo,
        isFetchingPublicGlobalBranding = _props2.isFetchingPublicGlobalBranding;


    return _React2.default.createElement(_CompanyLogo2.default, {
      compact: this.state.compact,
      branding: branding,
      isFetchingPublicGlobalBranding: isFetchingPublicGlobalBranding,
      hideLogo: hideLogo
    });
  },
  renderTroubleshootModeToggle: function renderTroubleshootModeToggle() {
    var _props3 = this.props,
        canTroubleshoot = _props3.canTroubleshoot,
        troubleshooting = _props3.troubleshooting,
        toggleTroubleshootMode = _props3.toggleTroubleshootMode;

    return _React2.default.createElement(_TroubleshootModeToggle2.default, {
      compact: this.state.compact,
      canTroubleshoot: canTroubleshoot,
      troubleshooting: troubleshooting,
      toggleTroubleshootMode: toggleTroubleshootMode
    });
  },
  render: function render() {
    return _React2.default.createElement(
      'div',
      { className: 'meetings-page', ref: this.getContainerNode },
      this.renderCompanyLogo(),
      this.renderTroubleshootModeToggle(),
      this.renderPotentialAlert(),
      this.renderBookInterface()
    );
  }
});

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    canAutoSubmitPropertyForm: (0, _AutoSubmitSelector.canAutoSubmitPropertyForm)(state),
    autoSubmitPropertyFormInvalid: (0, _AutoSubmitSelector.autoSubmitPropertyFormInvalid)(state),
    canTroubleshoot: (0, _TroubleshootingSelectors.canTroubleshootSelector)(state),
    embedded: state.embedded,
    forceMobile: state.forceMobile,
    isFetchingPublicAvailability: (0, _RequestStatusSelectors.getIsFetchingPublicAvailability)(state),
    isFetchingPublicGlobalBranding: (0, _RequestStatusSelectors.getIsFetchingPublicGlobalBranding)(state),
    isSalesStarter: state.isSalesStarter,
    shouldShowEmailForm: (0, _BookInfoSelectors.shouldShowEmailForm)(state),
    troubleshooting: state.troubleshooting,
    userMessage: state.userMessage,
    bookingLifecycle: state.bookingLifecycle,
    formState: state.formState,
    legalConsentEnabled: (0, _BookInfoSelectors.getLegalConsentEnabled)(state),
    legalConsentResponses: (0, _LegalConsentFormSelectors.getLegalConsentResponses)(state),
    // i18n
    languageFromSettings: (0, _BookInfoSelectors.getLanguageFromSettings)(state),
    localeFromProps: state.localeFromProps,
    localeFromSettings: (0, _BookInfoSelectors.getLocaleFromSettings)(state),
    shouldSetLocaleFromProps: (0, _LocalizationSelectors.shouldSetLocaleFromProps)(state),
    shouldSetLocaleFromSettings: (0, _LocalizationSelectors.shouldSetLocaleFromSettings)(state)
  };
}, _extends({}, BookActions, FormActions, UIActions))(Booking);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/page/BookingContainer.js
// module id = 285
// module chunks = 0